import React from 'react';
import Text from '../../Base/Text/Text';
import { NavigationStepperItemProps } from '../NavigationStepperItem';
import Tooltip from '../../Popup/Tooltip';
import NavigationButton from '../../Button/NavigationButton';
import { Badge } from '@meddihub/ui';

const SubTabNavigationStepperItem: React.FC<
	NavigationStepperItemProps
> = props => {
	const { item, onChange, activeKey, firstUpper = false } = props;

	let button = (
		<div>
			<Text tx={item.name} inline={true} firstUpper={firstUpper} />
			{!!item.badge && (
				<>
					{' '}
					<Badge tone='danger'>{item.badge}</Badge>
				</>
			)}
		</div>
	);

	if (item.tooltip) {
		button = (
			<Tooltip trigger={button} position='bottom center'>
				<Text tx={item.tooltip} firstUpper={firstUpper} />
			</Tooltip>
		);
	}

	if (item.renderButton) {
		button = item.renderButton();
	}

	return (
		<NavigationButton
			active={activeKey === item.key}
			disabled={item.disabled}
			onClick={() => onChange(item)}>
			{button}
		</NavigationButton>
	);
};

export default SubTabNavigationStepperItem;
